export const ACCOUNT_STATUSES = [
  { value: "lead", label: "Lead" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "trial", label: "Trial" },
  { value: "churned", label: "Churned" },
];

export const ACCOUNT_TIERS = [
  { value: "standard", label: "Standard" },
  { value: "starter", label: "Starter" },
  { value: "growth", label: "Growth" },
  { value: "enterprise", label: "Enterprise" },
];

export const PIPELINE_OWNERS = [
  { value: "karthik", label: "Karthik" },
  { value: "priya", label: "Priya" },
  { value: "anil", label: "Anil" },
];

export const PIPELINE_STAGES = [
  { value: "discovery", label: "Discovery" },
  { value: "qualification", label: "Qualification" },
  { value: "proposal", label: "Proposal" },
  { value: "negotiation", label: "Negotiation" },
  { value: "closed_won", label: "Closed Won" },
  { value: "closed_lost", label: "Closed Lost" },
];

export const LEAD_STATUSES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "qualified", label: "Qualified" },
  { value: "unqualified", label: "Unqualified" },
];

export const STATUS_TINT = {
  lead: "#F59E0B",
  active: "#22C55E",
  trial: "#0284C7",
  inactive: "#94A3B8",
  churned: "#DC2626",
};

export const TIER_TINT = {
  standard: "#64748B",
  starter: "#64748B",
  growth: "#0284C7",
  enterprise: "#7C3AED",
};
